import React, { useRef, useState, useEffect, useCallback } from 'react';
import "./AudioSlider.css";

const AudioSlider = ({ value, handleScrub, onHover, onPointerEnter, onPointerLeave, reference, setShowTooltip, audRef, handleTouchHover, currentTime, duration }) => {
  const [isThumbFocused, setIsThumbFocused] = useState(false)
  // Keyboard shortcuts
  const handleKeyPress = useCallback((event) => {
    if (event.keyCode === 39) {
      // right arrow clicked
      const newTime = audRef.current.currentTime + 10
      audRef.current.currentTime = newTime
    } else if (event.keyCode === 37) {
      // left arrow clicked
      const newTime = audRef.current.currentTime - 10
      audRef.current.currentTime = newTime
    }
  }, [audRef]);
  useEffect(() => {
    if (isThumbFocused) {
      document.addEventListener('keydown', handleKeyPress);
      return () => {
        document.removeEventListener('keydown', handleKeyPress);
      }
    }
  }, [isThumbFocused, handleKeyPress])
  const sliderThumbRef = useRef(null)
  const handleMove = (e) => {
    document.onpointerup = (e) => {
      const position = ((e.pageX - reference.current.getBoundingClientRect().left) / reference.current.offsetWidth) * 100
      handleScrub(position >= 100 ? 100 : position <= 0 ? 0 : position)
      document.onpointerup = null;
      document.onpointermove = null;
      setShowTooltip(false)
    }
    document.onpointermove = (e) => {
      e.preventDefault();
      const position = ((e.pageX - reference.current.getBoundingClientRect().left) / reference.current.offsetWidth) * 100
      handleScrub(position >= 100 ? 100 : position <= 0 ? 0 : position)
      setShowTooltip(true)
      onHover(e)
    }
    document.onpointercancel = (e) => {
      const position = ((e.pageX - reference.current.getBoundingClientRect().left) / reference.current.offsetWidth) * 100
      handleScrub(position >= 100 ? 100 : position <= 0 ? 0 : position)
      document.onpointerup = null;
      document.onpointermove = null;
      setShowTooltip(false)
    }
  }
  const handleTouchMove = (e) => {
    const touch = e.touches[0]
    const position = ((touch.pageX - reference.current.getBoundingClientRect().left) / reference.current.offsetWidth) * 100
    handleScrub(position >= 100 ? 100 : position <= 0 ? 0 : position)
    setShowTooltip(true)
    handleTouchHover(e)
  }
  const formatTimeAsText = (time) => {
    const minsCalc = Math.floor(parseFloat(time) / 60)
    const secondsCalc = Math.round((parseFloat(time) % 60))
    let curTime = ""
    if (minsCalc > 0) {
      curTime += `${minsCalc} ${minsCalc > 1 ? "minutes" : "minute"} and `
    }
    curTime += `${secondsCalc} ${secondsCalc > 1 || secondsCalc === 0 ? "seconds" : "second"}`
    return curTime
  }

  return (
    <div className="audio-slider-track-container"
      role="slider"
      aria-label="audio timeline slider in seconds"
      aria-valuenow={Math.round(currentTime)}
      aria-valuetext={formatTimeAsText(currentTime)}
      aria-valuemin={0}
      aria-valuemax={Math.round(duration)}
      ref={reference}
      onTouchMove={(e) => handleTouchMove(e)}
      onTouchEnd={(e) => setShowTooltip(false)}
      onPointerMove={onHover}
      onPointerEnter={onPointerEnter}
      onPointerLeave={onPointerLeave}
      onClick={(e) => handleScrub(((e.pageX - reference.current.getBoundingClientRect().left) / reference.current.offsetWidth) * 100)}
      onPointerOver={(e) => {
        setShowTooltip(true)
        onHover(e)
      }}
    >
      <div className="audio-slider-track"></div>
      <div className="audio-slider-track-elapsed" style={{ width: `${value >= 100 ? 100 : value}%` }}></div>
      <div className="audio-slider-thumb"
        ref={sliderThumbRef}
        tabIndex={1}
        style={{ left: `calc(${value >= 100 ? 100 : value}% - 8px` }}
        onPointerDown={handleMove}
        onFocus={() => setIsThumbFocused(true)}
        onBlur={() => setIsThumbFocused(false)}
      ></div>
    </div>
  )
}

export default AudioSlider;